import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=afe4051c&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=ts"
export * from "./Empty.vue?vue&type=script&lang=ts"
import style0 from "./Empty.vue?vue&type=style&index=0&id=afe4051c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe4051c",
  null
  
)

export default component.exports